import Vue from 'vue'
import Router from 'vue-router'
import AuthLayout from '@/layouts/Auth'
import MainLayout from '@/layouts/Main'
import store from '@/store'

Vue.use(Router)

const router = new Router({
  base: process.env.BASE_URL,
  mode: 'history',
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      redirect: 'dashboard',
      component: MainLayout,
      meta: {
        authRequired: true,
        hidden: true,
      },
      children: [
        // Dashboards
        {
          path: '/dashboard',
          meta: {
            title: 'Auction Dashboard',
            allowForRoles: ['operator', 'admin', 'participant'],
          },
          component: () => import('./views/belen/dashboard'),
        },
        {
          path: '/auctions',
          meta: {
            title: 'Auctions',
            allowForRoles: ['operator', 'admin', 'participant'],
          },
          component: () => import('./views/belen/auctions/list'),
        },
        {
          path: '/auctions/create',
          meta: {
            title: 'Create new auction',
            allowForRoles: ['operator', 'admin'],
          },
          component: () => import('./views/belen/auctions/create'),
        },
        {
          name: 'liveAuction',
          path: '/auctions/:id/live',
          meta: {
            title: 'Live auction',
            allowForRoles: ['operator', 'admin', 'participant'],
          },
          component: () => import('./views/belen/auctions/live'),
        },
        {
          path: '/orders',
          meta: {
            title: 'Orders',
            allowForRoles: ['operator', 'admin', 'participant'],
          },
          component: () => import('./views/belen/orders/list'),
        },
        {
          path: '/participants',
          meta: {
            title: 'Participants',
            allowForRoles: ['operator', 'admin'],
          },
          component: () => import('./views/belen/participants/list'),
        },
        {
          path: '/participants/new',
          meta: {
            title: 'New Participant',
            allowForRoles: ['operator', 'admin'],
          },
          component: () => import('./views/belen/participants/new'),
        },
        {
          path: '/participants/edit/:id',
          meta: {
            title: 'Edit Participant',
            allowForRoles: ['operator', 'admin'],
          },
          component: () => import('./views/belen/participants/new'),
          props: { isEdit: true },
        },
        {
          path: '/users',
          meta: {
            title: 'Users',
            allowForRoles: ['operator', 'admin'],
          },
          component: () => import('./views/belen/users/list'),
        },
        {
          path: '/users/new',
          meta: {
            title: 'New user',
            allowForRoles: ['operator', 'admin'],
          },
          component: () => import('./views/belen/users/new'),
        },
        {
          path: '/profile',
          meta: {
            title: 'My profile',
            allowForRoles: ['operator', 'admin', 'participant'],
          },
          component: () => import('./views/belen/users/profile'),
        },

        {
          path: '/users/edit/:id',
          meta: {
            title: 'Edit user',
            allowForRoles: ['operator', 'admin'],
          },
          component: () => import('./views/belen/users/new'),
          props: { isEdit: true },
        },
        {
          path: '/users/profile',
          meta: {
            title: 'My Profile',
            allowForRoles: ['operator', 'admin'],
          },
          component: () => import('./views/belen/users/new'),
        },
        {
          path: '/settings/company',
          meta: {
            title: 'Company settings',
            allowForRoles: ['operator', 'admin'],
          },
          component: () => import('./views/belen/settings/company'),
        },
        {
          path: '/settings/provisioning',
          meta: {
            title: 'Provisioning',
            allowForRoles: ['operator', 'admin'],
          },
          component: () => import('./views/belen/settings/provisioning'),
        },
        {
          path: '/settings/auctiontypes',
          meta: {
            title: 'Auction types',
            allowForRoles: ['operator', 'admin'],
          },
          component: () => import('./views/belen/settings/auctiontypes'),
        },
        {
          path: '/settings/api-keys',
          meta: {
            title: 'API Keys',
            allowForRoles: ['admin'],
          },
          component: () => import('./views/belen/settings/api-keys'),
        },
        {
          path: '/settings/admins',
          meta: {
            title: 'Admin users',
            allowForRoles: ['admin'],
          },
          component: () => import('./views/belen/settings/admins'),
        },
        {
          path: '/settings/reports',
          meta: {
            title: 'Excel Reports',
            allowForRoles: ['operator', 'admin'],
          },
          component: () => import('./views/belen/settings/reports'),
        },
        {
          path: '/day-ahead/results',
          meta: {
            title: 'Day-Ahead auctions',
            allowForRoles: ['admin'],
          },
          component: () => import('./views/belen/files/list'),
        },
        {
          path: '/day-ahead/members',
          meta: {
            title: 'EPEX Members',
            allowForRoles: ['admin'],
          },
          component: () => import('./views/belen/epex/members'),
        },
      ],
    },
    {
      path: '/bid-ask-curves',
      meta: {
        title: 'BidAskCurves',
        authRequired: false,
      },
      component: () => import('./views/belen/graphics/bidaskcurves'),
    },
    {
      path: '/day-ahead-results',
      meta: {
        title: 'DayAheadResults',
        authRequired: false,
      },
      component: () => import('./views/belen/graphics/dayaheadresult'),
    },
    {
      path: '/tables',
      meta: {
        title: 'Tables',
        authRequired: false,
      },
      component: () => import('./views/belen/graphics/tables'),
    },
    {
      path: '/stats',
      meta: {
        title: 'Statistic',
        authRequired: false,
      },
      component: () => import('./views/belen/graphics/stats'),
    },
    {
      path: '/status',
      meta: {
        title: 'Status',
        authRequired: false,
      },
      component: () => import('./views/belen/graphics/status'),
    },
    // System Pages
    {
      path: '/',
      component: AuthLayout,
      redirect: 'auth/login',
      children: [
        {
          path: '/auth/403',
          meta: {
            title: 'Error 403',
          },
          component: () => import('./views/auth/403'),
        },
        {
          path: '/auth/404',
          meta: {
            title: 'Error 404',
          },
          component: () => import('./views/auth/404'),
        },
        {
          path: '/auth/500',
          meta: {
            title: 'Error 500',
          },
          component: () => import('./views/auth/500'),
        },
        {
          path: '/auth/login',
          meta: {
            title: 'Sign In',
          },
          component: () => import('./views/auth/login'),
        },
        {
          path: '/auth/register',
          meta: {
            title: 'Sign Up',
          },
          component: () => import('./views/auth/register'),
        },
        {
          path: '/auth/forgot-password',
          meta: {
            title: 'Forgot Password',
          },
          component: () => import('./views/auth/forgot-password'),
        },
        {
          path: '/auth/reset-password/:token',
          meta: {
            title: 'Reset Password',
          },
          component: () => import('./views/auth/reset-password'),
        },
        {
          path: '/auth/lockscreen',
          meta: {
            title: 'Lockscreen',
          },
          component: () => import('./views/auth/lockscreen'),
        },
      ],
    },

    // Redirect to 404
    {
      path: '*',
      redirect: 'auth/404',
      hidden: true,
    },
  ],
})

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.authRequired)) {
    // if currently not authorized
    // lets try to autnorize and redirect if unsucessfull
    // solution for hard reload to stay on the same route
    if (!store.state.user.authorized) {
      Promise.all([store.dispatch('user/LOAD_CURRENT_ACCOUNT')])
        .then((response) => {
          if (!store.state.user.authorized) {
            next({
              path: '/auth/login',
              query: { redirect: to.fullPath },
            })
          } else {
            next()
          }
        })
        .catch((error) => {
          next({
            path: '/auth/login',
            query: { redirect: to.fullPath },
          })
        })
    } else {
      // console.log("Route", to)
      if (to.meta.allowForRoles) {
        if (to.meta.allowForRoles.indexOf(store.state.user.role) !== -1) {
          next()
        } else {
          next({
            path: '/auth/403',
          })
        }
      } else {
        next()
      }
    }
  } else {
    next()
  }
})

export default router
